import { EVENT_TYPE_CONSULTATION, EVENT_TYPE_THERAPY_SESSION } from 'src/consumer/constants'
import { isValidNumber } from 'src/consumer/helpers/utilFunctions'

export function isNewBookingFormDataValid(
  formData,
  appointmentTypesList,
  mentorsList,
  skipBilling,
) {
  console.log({ formData, appointmentTypesList, mentorsList, skipBilling })
  // if selected appointmentType.type does not match the mentor category return false
  const selectedApptTypeObj = appointmentTypesList?.find(
    (apptType) => apptType?.id === formData?.selectedAppointmentType,
  )
  const selectedMentorObj = mentorsList?.find((mentor) => mentor?.id === formData?.selectedMentor)

  if (selectedMentorObj?.id !== 'un-assigned') {
    if (
      selectedApptTypeObj?.type === EVENT_TYPE_THERAPY_SESSION &&
      !selectedMentorObj?.categories?.includes('therapist')
    ) {
      return false
    }
    if (
      selectedApptTypeObj?.type === EVENT_TYPE_CONSULTATION &&
      !selectedMentorObj?.categories?.includes('doctor')
    ) {
      return false
    }
  }

  if (!formData?.selectedMentor) {
    return false
  }
  if (!formData?.selectedAppointmentType) {
    return false
  }
  if (!formData?.startDate) {
    return false
  }
  if (!skipBilling) {
    if (!isValidNumber(formData?.fee)) {
      return false
    }
  }
  return true
}
